import React, {useState, useEffect} from 'react';
import isEmail from 'validator/lib/isEmail';
import {DebounceInput} from 'react-debounce-input';

  
async function checkEmail(token, sessionKey, email, tokenUpdate, setVal, setValidatedMail) {
  try {
    console.log("CHECK EMAIL");
    //console.log(email);
    //console.log(token);
    //console.log(sessionKey);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token.access_token);
    myHeaders.append("Accept", "application/json");

    var formdata = new FormData();
    formdata.append("session", sessionKey);
    formdata.append("mail", email);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    const response = await fetch(
      "https://ws.mediatoys.it/cliente/verifica_cliente",
      requestOptions
    );
    if (!response.ok) {
      if (response.status === 401) {
        // check error message???
        console.log("TOKEN ERROR!");
        tokenUpdate();
      }
      console.log(response);
      throw new Error("Network error " + response.status);
    }
    const respData = await response.json();
    //console.log(respData);
    if (respData.status === true) {
        setVal("Email già esistente. <a class='url-in-testo' target='_self' href='/login'> Fai login per proseguire</a>");
    } else {
        setValidatedMail(email);
        setVal("");
    }
    //setVal(respData.status);
    return respData;
  } catch (error) {
    console.log(error.message);
    return {status: false, error: true, message: error.message};
  }
    
}

function CartInputEmail(props) { 
  //const [MailExists, setMailExists] = useState(null);
  const [ErrorMsg, setErrorMsg] = useState(() => {
    const initialState = initErrorMsg();
    return initialState;
  });

  function initErrorMsg() {
    //console.log(props.name);
    if (!props.errList || props.errList.length === 0)
      return "";
    let txt = "";
    let errList = props.errList.filter((el) => el.id === props.name);
    if (errList.length > 0) {
      errList.forEach((el) => txt += el.msg+ " ");
    }   
    const initialState = txt;
    return initialState;
  };

  useEffect(() => {
    if (ErrorMsg === "") {
      let txt = initErrorMsg();
      if (txt !== "")
        setErrorMsg(txt);
    }
  }, [props.errList]);

  const startingStyle = {
    border: "1px solid #B3B3B3",
  };
  const validStyle = {
    border: "1px solid green",
  };
  const invalidStyle = {
    border: "1px solid red",
  };
  function setStyle() {
    if (!props.required) return startingStyle;
    if (props.value.length === 0 && ErrorMsg.length === 0) return startingStyle;
    if (ErrorMsg.length === 0) return validStyle;
    else return invalidStyle;
  }

  function checkField(ev) {
    props.change(ev.target.value);
    if (props.required) {
      if (ev.target.value.length === 0) {
        setErrorMsg("Si prega di non lasciare il campo vuoto.");
      } else {
        if (isEmail(ev.target.value)) {
          let res = checkEmail(
            props.token,
            props.sessionKey,
            ev.target.value,
            props.tokenUpdate,
            setErrorMsg,
            props.changeValidated
          );
          console.log(res);
        } else 
          setErrorMsg("Inserisci un indirizzo di email valido.");
      }
    } else 
      setErrorMsg("");
  }


  function labelUrl(label, urlText, url) {
    let txt =
      label + " (<a target='_self' href='" + url + "'>" + urlText + "</a>)";
    return { __html: txt };
  }

  function composeLabel(labelTxt) {
    if (props.url && props.url.length > 0) {
      return (
        <label
          dangerouslySetInnerHTML={labelUrl(labelTxt, props.urlText, props.url)}
        />
      );
    } else return <label>{labelTxt}</label>;
  }

  let label = props.lbl;
  if (props.required === true && label.length > 0) label += " *";

  //console.log(props);

  return (
    <div className={props.cssClass}>
      {props.labelRight === true ? null : composeLabel(label)}

      <DebounceInput
        value={props.value}
        minLength={3}
        debounceTimeout={400}
        onChange={(ev) => checkField(ev)}
        style={setStyle()}
      />

      {props.labelRight === true ? composeLabel(label) : null}

      {ErrorMsg.length > 0 ? (
        <div className="campo_vuoto_cart">
          <p dangerouslySetInnerHTML={{__html: ErrorMsg}} />
        </div>
      ) : null}
    </div>
  );
}

export default CartInputEmail;